import { Box, Text, Image, HStack } from '@chakra-ui/react';
import { Photo, Trip } from '@prisma/client';
import Link from 'next/link';
import React from 'react';
import ProgressiveImage from './ProgressiveImage';

interface Props {
	photo?: Photo & {
		trip: Trip & {
			name: string;
			author: {
				image: string;
			};
		};
	};
}

export default function GalleryImage({ photo }: Props) {
	return (
		<Box
			role='group'
			w='100%'
			mb='2'
			borderRadius='8px'
			d='inline-block'
			overflow='hidden'
			rounded='xl'
			pos='relative'>
			<Image src={photo?.url} objectFit='cover' alt='trip photo' />
			<Link passHref href={`/t/${photo?.tripId}`}>
				<HStack
					as='a'
					alignItems='center'
					justifyContent='space-between'
					p={2}
					bg='rgba(0,0,0,.35)'
					rounded='xl'
					backdropFilter='blur(3px)'
					position='absolute'
					bottom={1}
					left={1}
					overflow='hidden'
					w='calc(100% - 8px)'
					transition='all .2s'
					cursor='pointer'
					opacity={0}
					transform='translateY(8px)'
					_groupHover={{
						opacity: 1,
						transform: 'translateY(0px)',
					}}>
					<Text isTruncated noOfLines={1} fontWeight='medium' color='#fafafa' fontSize='sm'>
						{photo?.trip.name}
					</Text>
					<ProgressiveImage
						src={photo?.trip.author?.image as string}
						width={18}
						height={18}
						alt='author avatar'
						borderRadius='full'
					/>
				</HStack>
			</Link>
		</Box>
	);
}
